// pages/MovementsPage.tsx
import React, { useState, useEffect, useCallback } from "react";
//import { useMovementSummary } from "../../hooks/useMovements";
import  MovementsTable  from "./MovementsTable";
import { CreateMovementModal } from "./CreateMovementModal";

import { useUser } from '../../components/UserContext';
import { useMovementsApi } from "../../hooks/useMovementsApi";

import type { MovementSummaryDto } from "../../models/Movement";
import type { ArtworkStatusRefData } from "../../models/ArtworkStatus";
interface Props {

}

const MovementsPage: React.FC<Props> = () => {

    const api = useMovementsApi();
    const { getAccessToken } = useUser();

    const [data, setData] = useState<MovementSummaryDto | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const [showCreate, setShowCreate] = useState(false);
    const [selectedArtworkId, setSelectedArtworkId] = useState<number | null>(null);
    const [statuses, setStatuses] = useState<ArtworkStatusRefData[]>([]);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const accessToken = await getAccessToken();

            if (accessToken) {

                const result = await api.getSummary(accessToken);
                const statuses = await api.getStatuses(accessToken);

                setData(result);
                setStatuses(statuses);
            }
        } catch (e: any) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    if (loading) return (<div>Loading...</div>);

    return (
        <div className="page">
            <div className="page-header">
                <h1>Loans & Movements</h1>
                {/*<button className="btn btn--primary"*/}
                {/*    onClick={() => setShowCreate(true)}>*/}
                {/*    + Record Movement*/}
                {/*</button>*/}
            </div>

            {/* Summary strip */}
            {data && (
                <div className="kpi-strip">
                    <div className="kpi-card">
                        <div className="kpi-label">Active</div>
                        <div className="kpi-value">{data.totalActive}</div>
                    </div>
                    <div className="kpi-card kpi-card--warning">
                        <div className="kpi-label">Overdue</div>
                        <div className="kpi-value">{data.totalOverdue}</div>
                    </div>
                    <div className="kpi-card">
                        <div className="kpi-label">Due ≤ 30 days</div>
                        <div className="kpi-value">{data.dueWithin30Days}</div>
                    </div>
                    <div className="kpi-card">
                        <div className="kpi-label">On Loan</div>
                        <div className="kpi-value">{data.totalOnLoan}</div>
                    </div>
                    <div className="kpi-card">
                        <div className="kpi-label">On Exhibition</div>
                        <div className="kpi-value">{data.totalOnExhibition}</div>
                    </div>
                    <div className="kpi-card">
                        <div className="kpi-label">In Transit</div>
                        <div className="kpi-value">{data.totalInTransit}</div>
                    </div>
                    <div className="kpi-card">
                        <div className="kpi-label">Total Insured</div>
                        <div className="kpi-value">
                            {data.insuranceCurrency}{" "}
                            {data.totalInsuredValue.toLocaleString()}
                        </div>
                    </div>
                </div>
            )}

            {/* Active movements table */}
            {loading && <p>Loading…</p>}
            {data && (
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <h2>Active Movements</h2>
                    </div>
                    <div className="dashboard-card-body">
                        <MovementsTable
                            movements={data.allActive}
                            statuses={statuses}
                            onRefresh={load}
                        />
                    </div>
                </div>
            )}

            {/* Create modal — needs artwork picker if launched from this page */}
            {showCreate && (
                <CreateMovementModal
                    artworkId={selectedArtworkId ?? 0}
                    artworkTitle="Select Artwork"
                    statuses={statuses}
                    onClose={() => setShowCreate(false)}
                    onCreated={load}
                />
            )}
        </div>
    );
};

export default MovementsPage;